<div class="page-title-area">
    <img src="assets/images/post-sales.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Post Sales Support</h2>
            <!-- <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Case Studies Details</li>
            </ul> -->
        </div>
    </div>

    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <!-- <div class="row">
            <div class="col-12">
                <div class="services-img mb">
                    <img src="assets/images/case-details/1.jpg" alt="Image">
                </div>
            </div>

            <div class="col-12">
                <div class="services-details-text">
                    <h2>Joe’s Company Software Development Case</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum  not only five centuries, but also the leap into.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a dictionary of over 200 Latin words, combined with a</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc generators on the Internet tend to repeat predefined chunks as necessary, making this the first generator dictionary of over 200 Latin words, combined with a.</p>
                </div>
            </div>
        </div> -->
        <!-- <div class="section-title">
            <div style="display: flex; flex-direction: row; text-align: center; justify-content: center;">
            <div><a href="https://www.jainuniversity.ac.in/" target="_blank"><h2> Jain University  &nbsp;</h2></a></div>
            <div style="margin-top: 4px;">
                <a href="https://www.jainuniversity.ac.in/" target="_blank"><span class="material-symbols-outlined" style="font-size: 35px; font-weight: 600;">
                    arrow_outward
                    </span></a>
            </div>
            </div>
        </div> -->

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/solutions-details/48.png" alt="Person">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>Post Sales Support </h3>
                    <p>When you need any repair OR Service on your Apple Device, We are just a call away for you to fetch our onsite support at your location. We pride ourselves on being a trusted destination for all your Apple device needs, offering expert post-sales support.</p>
                    <p>Our Associated team of Apple Certified Technicians and Engineers possess the advanced skills required to ensure that your Apple devices, including Macintosh, iPhone, iPad, and others, are functioning optimally. In Association with Authorized Service Provider we provide onsite support for Apple Devices, ensuring convenience and assistance right where you need it.</p>
                    <p>Our Associated Service Partner is Authorised to order Apple Genuine Spares online with the included warranty and coverage. One of our key services is AppleCare+ Repairs, where we provide prompt and efficient repair services covered under AppleCare+ to keep your devices protected against unexpected breakdowns.</p>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <!-- <h5>Apple Developer Program</h5>         -->
                    <p>Our customer-centric approach ensures that you receive personalised service and expert advice tailored to your specific device needs.Furthermore, we provide comprehensive diagnostics to accurately identify and rectify any issues your devices may face.Whether it's a simple software glitch or a complex hardware issue, our team is equipped to handle it all.Trust Apple Genie Pars to deliver exceptional service and support for all your Apple device needs.</p>
                    <p>In addition to this, we cater to Out of Warranty Repairs, ensuring that your beloved Apple products still receive the best care even after the warranty period has expired.Our technicians use genuine Apple Parts to guarantee the quality and longevity of repairs, maintaining the high standards you expect from Apple.We understand the importance of having your devices up and running, which is why we offer quick turnaround times without compromising on service quality.</p>
                </div>

                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/solutions-details/34.png" alt="Person">
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="services-img mb-qc">
                        <img src="assets/images/solutions-details/5.png" alt="Image">
                    </div>
                </div>

                <div class="col-lg-6">
                    <h3>Conclusion</h3>
                    <p>The successful installation and configuration of the Apple Lab's iMacs at JAIN (Deemed-to-be University) have significantly enhanced the learning environment, positioning the university as a leader in integrating technology into education.</p>
                </div>
            </div>
        </div> -->
        
        <!-- <div class="scrives-item-3 mt-4">
            <div class="row align-items-center">
                <div class="col-lg-12">
                    <h3>Conclusion</h3>
                    <p>Essilor’s adoption of iPads highlights the importance of digital tools in modernising sales operations, ultimately enhancing customer engagement and business outcomes.</p>   
                </div>
            </div>
        </div> -->
    </div>
</section>